import apiClient from '../api/client';
import { ECPT_ENDPOINTS } from '../api/endpoints';
import { ENV } from '../../env';

export interface AccessRequestApp {
  name: string;
  display_name: string;
  description?: string;
  requires_dispo_index?: boolean;
  dispo_index_label?: string;
  dispo_index_description?: string;
}

export interface AccessRequestAppsResponse {
  apps: AccessRequestApp[];
}

export interface AccessRequestSubmitPayload {
  user_name: string;
  user_email: string;
  user_short_id: string;
  app_name: string;
  dispo_index?: string;
  role?: string;
  purpose: string;
  additional_info?: string;
}

export interface AccessRequestRecipient {
  name: string;
  email: string;
}

export interface AccessRequestSubmitResponse {
  success: boolean;
  message: string;
  request_id: string;
  status: 'pending' | 'approved' | 'rejected' | 'cancelled';
  recipients?: AccessRequestRecipient[];
  created_at: string;
}

export interface AccessRequestStatusResponse {
  request_id: string;
  user_name: string;
  user_email: string;
  user_short_id: string;
  app_name: string;
  status: 'pending' | 'approved' | 'rejected' | 'cancelled';
  purpose: string;
  created_at: string;
  updated_at: string;
  approved_at?: string | null;
  rejected_at?: string | null;
}

const AUTH_BASE = { baseURL: ENV.AUTH_BASE_URL };

class EcptAccessRequestService {
  async getApps() {
    const { data } = await apiClient.get<AccessRequestAppsResponse>(ECPT_ENDPOINTS.ACCESS_REQUEST_APPS, AUTH_BASE);
    return data;
  }

  async submit(payload: AccessRequestSubmitPayload) {
    const body: AccessRequestSubmitPayload = {
      ...payload,
      user_email: payload.user_email.trim().toLowerCase(),
      user_short_id: payload.user_short_id.trim().toLowerCase(),
      user_name: payload.user_name.trim(),
      app_name: payload.app_name.trim(),
      purpose: payload.purpose.trim(),
    };

    const { data } = await apiClient.post<AccessRequestSubmitResponse>(ECPT_ENDPOINTS.ACCESS_REQUEST_SUBMIT, body, AUTH_BASE);
    return data;
  }

  async getStatus(requestId: string) {
    const { data } = await apiClient.get<AccessRequestStatusResponse>(
      ECPT_ENDPOINTS.ACCESS_REQUEST_STATUS(requestId),
      AUTH_BASE,
    );
    return data;
  }
}

const ecptAccessRequestService = new EcptAccessRequestService();
export default ecptAccessRequestService;
